import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import YouTubeService from './pages/YouTubeService';
import LinkInsertions from './pages/LinkInsertions';
import BrandMentions from './pages/BrandMentions';
import QuoraService from './pages/QuoraService';
import RedditService from './pages/RedditService';
import GoogleMapsService from './pages/GoogleMapsService';
import ProductReviews from './pages/ProductReviews';
import PressReleaseService from './pages/PressReleaseService';
import GuestPosts from './pages/GuestPosts';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0B0F19] flex flex-col font-sans text-slate-300 antialiased">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/youtube" element={<YouTubeService />} />
            <Route path="/services/link-insertions" element={<LinkInsertions />} />
            <Route path="/services/brand-mentions" element={<BrandMentions />} />
            <Route path="/services/quora" element={<QuoraService />} />
            <Route path="/services/reddit" element={<RedditService />} />
            <Route path="/services/google-maps" element={<GoogleMapsService />} />
            <Route path="/services/product-reviews" element={<ProductReviews />} />
            <Route path="/services/press-releases" element={<PressReleaseService />} />
            <Route path="/services/guest-posts" element={<GuestPosts />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;